/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_TitleInputs */

const en_svr_guidance_onsite_title = /** @type {(inputs: Svr_Guidance_Onsite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guidance for Onsite Protocol`)
};

const ja_svr_guidance_onsite_title = /** @type {(inputs: Svr_Guidance_Onsite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場プロトコルガイダンス`)
};

const fr_svr_guidance_onsite_title = /** @type {(inputs: Svr_Guidance_Onsite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide pour le protocole sur site`)
};

const de_svr_guidance_onsite_title = /** @type {(inputs: Svr_Guidance_Onsite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfaden für das Vor-Ort-Protokoll`)
};

/**
* | output |
* | --- |
* | "Guidance for Onsite Protocol" |
*
* @param {Svr_Guidance_Onsite_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_title = /** @type {((inputs?: Svr_Guidance_Onsite_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_title(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_title(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_title(inputs)
	return de_svr_guidance_onsite_title(inputs)
});